module.exports = __webpack_public_path__ + "img/swiper-1.9f892314.png";